function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import PlunkDropDown from "../../components/plunk-dropdown";
import { Loader } from "../../components/loaders";
import { Pending } from "../../components/analytics-kit";
import { hasTenantFeature } from "../../functions/tenant-features";
import { getGlobalRange, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
import { getRepGaps } from "./sales-api";
import { count, displayTitle, catLabel, rangeWithDates } from "../products/px-common";
import { dateShort, nameOf, place, loadRoster, findRep, copyText, Thumb, RepSubTop, NotYet } from "./rep-common";

/*
 * "What other reps sell that <rep>'s dealers don't buy" (Territory & Reps redesign 2026-10-09, board 7).
 * Route: /Territory/:range/rep/:repCode/compare
 *
 * GET /v1/sales/reps/{range}/{repCode}/gaps?compare=all|{repCode}&category=&series=&minDealers=10
 * (sales-api.js getRepGaps). Each product: share of the comparison reps' dealers buying it against
 * the share of this rep's dealers buying it; the gap in points; the rep's dealers who have not
 * bought it (the call list). Fail-soft: null = route not live yet, shown as a calm line.
 */

const MIN_DEALERS = 10;
// Gap / lead rule (matches the backend's isGap / isLead): 10+ points apart, or twice as often and 3+ points apart.
const isGapOf = (o, m) => o - m >= 10 || o >= 2 * m && o - m >= 3;
// Series by default: single products are each bought by a small share of dealers, so gaps show at series level.
const itemId = it => String(it.sku || it.series || "");
const ROWS_SHOWN = 20;
const arr = v => Array.isArray(v) ? v : [];
const num0 = v => Number(v) || 0;
class RepCompareComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "set", k => v => this.setState({
      [k]: v
    }, () => this.load()));
    _defineProperty(this, "openList", async (it, key, open) => {
      this.setState({
        open: open ? "" : key
      });
      const id = itemId(it);
      if (open || !id || it.missingDealersIncluded !== false || (this.state.lists || {})[id]) return;
      const st = this.state;
      const one = it.sku ? {
        sku: it.sku,
        grain: "product",
        series: st.series || undefined
      } : {
        series: it.series,
        grain: "series"
      };
      try {
        const d = await getRepGaps(this.range(), this.repCode(), {
          compare: st.compare || "all",
          category: st.category || undefined,
          minDealers: MIN_DEALERS,
          ...one
        });
        const row = d && arr(d.items).find(x => itemId(x) === id);
        if (this._alive) this.setState({
          lists: {
            ...(this.state.lists || {}),
            [id]: row || {
              missingDealers: []
            }
          }
        });
      } catch (e) {
        if (this._alive) this.setState({
          lists: {
            ...(this.state.lists || {}),
            [id]: {
              missingDealers: [],
              failed: true
            }
          }
        });
      }
    });
    _defineProperty(this, "copyList", async (it, repName) => {
      const title = displayTitle(it.title) || it.sku || it.series;
      const lines = this.missingFor(it).map(m => [nameOf(m.name, m.dealerId), place(m.city, m.region), m.lastOrder ? `last order ${dateShort(m.lastOrder)}` : "no orders yet"].filter(Boolean).join(", "));
      const text = `${repName}'s dealers who haven't bought ${it.sku ? "" : "anything from "}${title}${it.sku ? ` (${it.sku})` : ""}:\n${lines.map(l => `- ${l}`).join("\n")}`;
      const ok = await copyText(text);
      if (!this._alive) return;
      const cid = itemId(it) || title;
      this.setState({
        copied: ok ? cid : "fail:" + cid
      });
      clearTimeout(this._copyT);
      this._copyT = setTimeout(() => this._alive && this.setState({
        copied: ""
      }), 4000);
    });
    this.state = {
      roster: [],
      data: undefined,
      error: false,
      busy: false,
      compare: "all",
      category: "",
      series: "",
      grain: "series",
      filter: "gaps",
      all: false,
      open: "",
      copied: "",
      cats: [],
      seriesList: []
    };
    this._alive = true;
    this._seq = 0;
  }
  range() {
    return this.props.params && this.props.params.range || getGlobalRange();
  }
  repCode() {
    return decodeURIComponent(this.props.params && this.props.params.repCode || "");
  }
  repPath() {
    return `/Territory/${this.range()}/rep/${encodeURIComponent(this.repCode())}`;
  }
  componentDidMount() {
    this.boot();
    this._periodTok = subscribePeriod(({
      range
    }) => {
      if (!this._alive || !range || range === this.range()) return;
      this.props.history.push(`/Territory/${range}/rep/${encodeURIComponent(this.repCode())}/compare`);
    });
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._periodTok);
    clearTimeout(this._copyT);
  }
  componentDidUpdate(prev) {
    const k = p => `${p.params && p.params.range || ""}|${p.params && p.params.repCode || ""}`;
    if (k(prev) !== k(this.props)) this.setState({
      data: undefined,
      error: false,
      open: "",
      cats: [],
      seriesList: []
    }, () => this.boot());
  }
  boot() {
    loadRoster(this.range()).then(roster => this._alive && this.setState({
      roster
    }));
    this.load();
  }
  async load() {
    const seq = ++this._seq;
    const st = this.state;
    this.setState({
      busy: true,
      error: false,
      open: "",
      lists: {}
    });
    try {
      const d = await getRepGaps(this.range(), this.repCode(), {
        compare: st.compare || "all",
        category: st.category || undefined,
        series: st.grain === "product" ? st.series || undefined : undefined,
        minDealers: MIN_DEALERS,
        grain: st.grain
      });
      if (!this._alive || seq !== this._seq) return;
      if (d === null) {
        this.setState({
          data: null,
          busy: false
        });
        return;
      }
      // Keep every category / series seen so the pickers do not shrink to the current filter.
      const cats = new Set(this.state.cats),
        ser = new Set(this.state.seriesList);
      arr(d.items).forEach(it => {
        if (it.category) cats.add(String(it.category));
        if (it.series) ser.add(String(it.series));
      });
      this.setState({
        data: d,
        busy: false,
        all: false,
        cats: Array.from(cats).sort((a, b) => catLabel(a).localeCompare(catLabel(b))),
        seriesList: Array.from(ser).sort((a, b) => nameOf(a).localeCompare(nameOf(b)))
      });
    } catch (e) {
      if (this._alive && seq === this._seq) this.setState({
        error: true,
        busy: false,
        data: this.state.data === undefined ? false : this.state.data
      });
    }
  }
  // Shares may arrive as fractions (0.48) or percents (48); one scale for the whole response.
  scale() {
    const items = arr(this.state.data && this.state.data.items);
    return items.some(it => num0(it.repShare) > 1 || num0(it.otherShare) > 1) ? 1 : 100;
  }

  // Large responses leave some products' dealer lists out (missingDealersIncluded: false);
  // opening the call list then asks for that one product (?sku=) and keeps the answer.
  missingFor(it) {
    const fetched = (this.state.lists || {})[itemId(it)];
    if (fetched) return arr(fetched.missingDealers);
    return arr(it.missingDealers);
  }
  render() {
    if (!hasTenantFeature("territoryRep")) {
      return /*#__PURE__*/React.createElement("div", {
        className: "territory-view ec-view ecc-view trr-view"
      }, /*#__PURE__*/React.createElement("div", {
        className: "trr-body"
      }, /*#__PURE__*/React.createElement(NotYet, null, "Territory & Reps is not configured for this workspace.")));
    }
    const st = this.state;
    const range = this.range();
    const code = this.repCode();
    const me = findRep(st.roster, code);
    const name = nameOf(me && me.name, code);
    const d = st.data || null;
    const other = st.compare !== "all" ? findRep(st.roster, st.compare) : null;
    const otherName = st.compare === "all" ? "all other reps" : nameOf(other && other.name, st.compare);
    const otherWho = st.compare === "all" ? "all other reps' dealers" : `${otherName}'s ${d && d.compareDealers != null ? count(d.compareDealers) + " " : ""}dealers`;
    const meta = `Share of dealers buying each ${st.grain === "product" ? "product" : "series"}: ${otherWho} vs ${name}'s ${d && d.repDealers != null ? count(d.repDealers) + " " : ""}dealers · ${rangeWithDates(range)}`;
    const crumbs = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
      to: `/Territory/${range}`
    }, "Territory & Reps"), " \xB7 ", /*#__PURE__*/React.createElement(Link, {
      to: this.repPath()
    }, name), " \xB7 Compare");
    const repOptions = [["all", "Compare with: All other reps"], ...st.roster.filter(r => String(r.repCode || "").trim() && String(r.repCode).trim().toLowerCase() !== code.trim().toLowerCase()).map(r => [String(r.repCode).trim(), `Compare with: ${nameOf(r.name, r.repCode)}`]).sort((a, b) => a[1].localeCompare(b[1]))];
    if (st.compare !== "all" && !repOptions.some(([v]) => v === st.compare)) repOptions.push([st.compare, `Compare with: ${otherName}`]);
    const catOptions = [["", "All categories"], ...st.cats.map(c => [c, catLabel(c)])];
    const serOptions = [["", "All series"], ...st.seriesList.map(s => [s, nameOf(s)])];
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view ec-view ecc-view trr-view"
    }, /*#__PURE__*/React.createElement(RepSubTop, {
      crumbs: crumbs,
      title: `What other reps sell that ${name}'s dealers don't buy`,
      meta: meta,
      onBack: () => this.props.history.push(this.repPath())
    }, /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "250px",
      value: st.compare,
      options: repOptions,
      onChange: this.set("compare")
    }), /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "180px",
      value: st.category,
      options: catOptions,
      onChange: this.set("category")
    }), st.grain === "product" && (st.seriesList.length || st.series) ? /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "170px",
      value: st.series,
      options: serOptions,
      onChange: this.set("series")
    }) : null), /*#__PURE__*/React.createElement("div", {
      className: "trr-body"
    }, st.data === undefined ? /*#__PURE__*/React.createElement(Loader, null) : st.data === null ? /*#__PURE__*/React.createElement(NotYet, null, "The comparison with other reps is not available yet for this workspace. It appears here once the sales service is updated.") : st.data === false ? /*#__PURE__*/React.createElement(NotYet, null, "We couldn't load the comparison right now. Try again in a moment.") : this.renderBody(name)));
  }
  renderBody(name) {
    const st = this.state;
    const d = st.data;
    const sum = d.summary || {};
    const items = arr(d.items);
    const sc0 = this.scale();
    const gapOf = it => it.isGap != null ? !!it.isGap : isGapOf(num0(it.otherShare) * sc0, num0(it.repShare) * sc0);
    const leadOf = it => it.isLead != null ? !!it.isLead : isGapOf(num0(it.repShare) * sc0, num0(it.otherShare) * sc0);
    const gaps = items.filter(gapOf).sort((a, b) => num0(b.gapPts) - num0(a.gapPts));
    const leads = items.filter(leadOf).sort((a, b) => num0(a.gapPts) - num0(b.gapPts));
    const bySeries = st.grain !== "product";
    const unit = bySeries ? "series" : "product",
      units = bySeries ? "series" : "products";
    const all = items.slice().sort((a, b) => num0(b.gapPts) - num0(a.gapPts));
    const list = st.filter === "leads" ? leads : st.filter === "all" ? all : gaps;
    const shown = st.all ? list : list.slice(0, ROWS_SHOWN);
    const repDealers = d.repDealers != null ? num0(d.repDealers) : null;
    const bigGaps = sum.bigGaps != null ? num0(sum.bigGaps) : gaps.length;
    const leadsN = sum.leads != null ? num0(sum.leads) : leads.length;
    const sc = this.scale();
    const otherLabel = st.compare === "all" ? "Other reps' dealers buying it" : `${nameOf((findRep(st.roster, st.compare) || {}).name, st.compare)}'s dealers buying it`;
    const listTitle = st.filter === "leads" ? `Where ${name} leads` : st.filter === "all" ? `Every ${unit}, biggest gaps first` : "Biggest gaps first";
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "trr-tiles three"
    }, /*#__PURE__*/React.createElement("div", {
      className: "trr-tile"
    }, /*#__PURE__*/React.createElement("span", {
      className: "l"
    }, bySeries ? "Series" : "Products", " with a big gap"), /*#__PURE__*/React.createElement("b", {
      className: "v"
    }, count(bigGaps)), /*#__PURE__*/React.createElement("span", {
      className: "s"
    }, "other reps' dealers buy them 10+ points more often, or twice as often")), /*#__PURE__*/React.createElement("div", {
      className: "trr-tile"
    }, /*#__PURE__*/React.createElement("span", {
      className: "l"
    }, "Dealers to call"), /*#__PURE__*/React.createElement("b", {
      className: "v"
    }, sum.dealersToCall != null ? count(sum.dealersToCall) : "-", repDealers != null ? ` of ${count(repDealers)}` : ""), /*#__PURE__*/React.createElement("span", {
      className: "s"
    }, "missing at least one of those ", units)), /*#__PURE__*/React.createElement("div", {
      className: "trr-tile"
    }, /*#__PURE__*/React.createElement("span", {
      className: "l"
    }, "Where ", name, " leads"), /*#__PURE__*/React.createElement("b", {
      className: "v"
    }, count(leadsN), " ", leadsN === 1 ? unit : units), /*#__PURE__*/React.createElement("span", {
      className: "s"
    }, "their dealers buy more often than others'"))), /*#__PURE__*/React.createElement("section", {
      className: `trr-card trr-gaps${st.busy ? " busy" : ""}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "trr-card-head wrap"
    }, /*#__PURE__*/React.createElement("b", {
      className: "trr-h"
    }, listTitle), /*#__PURE__*/React.createElement("span", {
      className: "trr-muted trr-small"
    }, "only ", units, " bought by at least ", MIN_DEALERS, " dealers, so one big order doesn't skew it"), /*#__PURE__*/React.createElement("span", {
      className: "ecc-spacer"
    }), /*#__PURE__*/React.createElement("span", {
      className: "trr-pills",
      role: "group",
      "aria-label": "Compare by"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: bySeries ? "on" : "",
      onClick: () => this.setState({
        grain: "series",
        filter: "gaps",
        all: false,
        open: ""
      }, () => this.load())
    }, "By series"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: !bySeries ? "on" : "",
      onClick: () => this.setState({
        grain: "product",
        filter: "gaps",
        all: false,
        open: ""
      }, () => this.load())
    }, "By product")), /*#__PURE__*/React.createElement("span", {
      className: "trr-pills",
      role: "group",
      "aria-label": "Show"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: st.filter === "gaps" ? "on" : "",
      onClick: () => this.setState({
        filter: "gaps",
        all: false,
        open: ""
      })
    }, "Gaps ", count(gaps.length)), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: st.filter === "leads" ? "on" : "",
      onClick: () => this.setState({
        filter: "leads",
        all: false,
        open: ""
      })
    }, name, " leads ", count(leads.length)), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: st.filter === "all" ? "on" : "",
      onClick: () => this.setState({
        filter: "all",
        all: false,
        open: ""
      })
    }, "All ", count(items.length)))), /*#__PURE__*/React.createElement("div", {
      className: "trr-legend"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
      className: "trr-key other"
    }), otherLabel), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
      className: "trr-key rep"
    }), name, "'s dealers buying it")), st.error ? /*#__PURE__*/React.createElement("p", {
      className: "trr-muted"
    }, "We couldn't refresh the comparison. Change a filter to try again.") : null, st.busy && !items.length ? /*#__PURE__*/React.createElement(Pending, {
      h: 260
    }) : !list.length ? /*#__PURE__*/React.createElement("p", {
      className: "trr-muted trr-pad"
    }, st.filter === "leads" ? `No ${units} where ${name}'s dealers buy clearly more often in this view.` : st.filter === "gaps" ? `No ${unit} with a big gap. ${name}'s dealers buy in line with the comparison.` : `No ${units} bought by at least ${MIN_DEALERS} dealers in this period.`) : /*#__PURE__*/React.createElement("div", {
      className: "trr-table trr-gap",
      role: "table"
    }, /*#__PURE__*/React.createElement("div", {
      className: "trr-th",
      role: "row"
    }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null, bySeries ? "Series" : "Product"), /*#__PURE__*/React.createElement("span", null, "Category"), /*#__PURE__*/React.createElement("span", null, "Share of dealers buying"), /*#__PURE__*/React.createElement("span", {
      className: "n"
    }, "Gap"), /*#__PURE__*/React.createElement("span", null, "Dealers missing it"), /*#__PURE__*/React.createElement("span", null)), shown.map((it, i) => this.renderRow(it, i, name, repDealers, sc))), /*#__PURE__*/React.createElement("div", {
      className: "trr-foot"
    }, /*#__PURE__*/React.createElement("span", null, "\"Call list\" shows the dealers who haven't bought the product, with their last order, ready to copy and share with the rep."), list.length > ROWS_SHOWN ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "trr-textlink",
      onClick: () => this.setState({
        all: !st.all
      })
    }, st.all ? "Show fewer" : `Show all ${count(list.length)}`) : null)));
  }
  renderRow(it, i, name, repDealers, sc) {
    const st = this.state;
    const range = this.range();
    const sku = String(it.sku || "");
    const id = itemId(it);
    const key = id || `row-${i}`;
    const other = Math.max(0, Math.min(100, Math.round(num0(it.otherShare) * sc)));
    const mine = Math.max(0, Math.min(100, Math.round(num0(it.repShare) * sc)));
    const gap = Math.round(num0(it.gapPts));
    const missing = this.missingFor(it);
    const listPending = it.missingDealersIncluded === false && !(st.lists || {})[sku];
    const listFailed = !!((st.lists || {})[sku] && (st.lists || {})[sku].failed);
    const missingN = it.missingCount != null ? num0(it.missingCount) : missing.length;
    const firstTwo = missing.slice(0, 2).map(m => nameOf(m.name, m.dealerId));
    const more = missingN - firstTwo.length;
    const open = st.open === key;
    const copied = st.copied === (id || displayTitle(it.title));
    const copyFailed = st.copied === "fail:" + (id || displayTitle(it.title));
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: key
    }, /*#__PURE__*/React.createElement("div", {
      className: `trr-tr${open ? " open" : ""}`,
      role: "row"
    }, /*#__PURE__*/React.createElement(Thumb, {
      src: it.image || it.imageUrl
    }), /*#__PURE__*/React.createElement("span", {
      className: "trr-stack"
    }, sku ? /*#__PURE__*/React.createElement(Link, {
      className: "trr-plink",
      to: {
        pathname: `/Territory/${range}/product/${encodeURIComponent(sku)}`,
        state: it.title ? {
          title: it.title
        } : undefined
      }
    }, /*#__PURE__*/React.createElement("b", null, displayTitle(it.title) || sku)) : it.series ? /*#__PURE__*/React.createElement(Link, {
      className: "trr-plink",
      to: `/Products/${range}/family/${encodeURIComponent(it.series)}`
    }, /*#__PURE__*/React.createElement("b", null, displayTitle(it.title) || nameOf(it.series))) : /*#__PURE__*/React.createElement("b", null, displayTitle(it.title)), /*#__PURE__*/React.createElement("span", {
      className: "trr-sub trr-ell"
    }, sku ? [sku, it.series ? nameOf(it.series) : ""].filter(Boolean).join(" · ") : [it.productCount != null ? `${count(it.productCount)} product${num0(it.productCount) === 1 ? "" : "s"}` : "", arr(it.topProducts).length ? `top: ${arr(it.topProducts).slice(0, 2).map(p => p.sku || displayTitle(p.title)).join(", ")}` : ""].filter(Boolean).join(" · "))), /*#__PURE__*/React.createElement("span", {
      className: "trr-ell"
    }, it.category ? catLabel(it.category) : /*#__PURE__*/React.createElement("span", {
      className: "trr-muted"
    }, "-")), /*#__PURE__*/React.createElement("span", {
      className: "trr-bars"
    }, /*#__PURE__*/React.createElement("span", {
      className: "trr-barrow",
      title: `${other}% of the comparison dealers bought it`
    }, /*#__PURE__*/React.createElement("span", {
      className: "trr-bar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "other",
      style: {
        width: `${other}%`
      }
    })), /*#__PURE__*/React.createElement("span", {
      className: "trr-pct"
    }, other, "%")), /*#__PURE__*/React.createElement("span", {
      className: "trr-barrow",
      title: `${mine}% of ${name}'s dealers bought it`
    }, /*#__PURE__*/React.createElement("span", {
      className: "trr-bar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rep",
      style: {
        width: `${mine}%`
      }
    })), /*#__PURE__*/React.createElement("span", {
      className: "trr-pct"
    }, mine, "%"))), /*#__PURE__*/React.createElement("b", {
      className: `n trr-gapn ${gap > 0 ? "behind" : gap < 0 ? "ahead" : ""}`
    }, gap > 0 ? `+${gap}` : gap < 0 ? `−${Math.abs(gap)}` : "0", " pts"), /*#__PURE__*/React.createElement("span", {
      className: "trr-stack"
    }, missingN > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, count(missingN), repDealers != null ? ` of ${count(repDealers)}` : "", " haven't bought it"), firstTwo.length ? /*#__PURE__*/React.createElement("span", {
      className: "trr-sub trr-ell"
    }, firstTwo.join(", "), more > 0 ? ` +${count(more)}` : "") : null) : /*#__PURE__*/React.createElement("span", {
      className: "trr-muted"
    }, "Every dealer has bought it")), /*#__PURE__*/React.createElement("span", {
      className: "n"
    }, missingN > 0 ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: `trr-btn small${open ? " on" : ""}`,
      "aria-expanded": open,
      onClick: () => this.openList(it, key, open)
    }, open ? "Hide list" : "Call list") : null)), open ? /*#__PURE__*/React.createElement("div", {
      className: "trr-calllist",
      role: "region",
      "aria-label": `Call list for ${displayTitle(it.title) || id}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "trr-cl-head"
    }, /*#__PURE__*/React.createElement("b", null, count(missingN), " of ", name, "'s dealers haven't bought ", sku ? "" : "anything from ", displayTitle(it.title) || id), /*#__PURE__*/React.createElement("span", {
      className: "ecc-spacer"
    }), copyFailed ? /*#__PURE__*/React.createElement("span", {
      className: "trr-muted trr-small"
    }, "Copy didn't work in this browser. Select the list and copy it instead.") : null, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "trr-btn small",
      disabled: !missing.length,
      onClick: () => this.copyList(it, name)
    }, copied ? "Copied" : "Copy list")), missing.length ? /*#__PURE__*/React.createElement("div", {
      className: "trr-cl-rows"
    }, /*#__PURE__*/React.createElement("div", {
      className: "trr-cl-row th"
    }, /*#__PURE__*/React.createElement("span", null, "Dealer"), /*#__PURE__*/React.createElement("span", null, "City"), /*#__PURE__*/React.createElement("span", null, "Last order")), missing.map((m, j) => {
      const id = String(m.dealerId || m.accountNumber || "");
      return /*#__PURE__*/React.createElement("div", {
        className: "trr-cl-row",
        key: id || j
      }, id ? /*#__PURE__*/React.createElement(Link, {
        className: "trr-plink",
        to: `/Territory/${range}/customer/${encodeURIComponent(id)}`
      }, nameOf(m.name, id)) : /*#__PURE__*/React.createElement("span", null, nameOf(m.name)), /*#__PURE__*/React.createElement("span", null, place(m.city, m.region) || /*#__PURE__*/React.createElement("span", {
        className: "trr-muted"
      }, "-")), /*#__PURE__*/React.createElement("span", null, m.lastOrder ? dateShort(m.lastOrder) : /*#__PURE__*/React.createElement("span", {
        className: "trr-muted"
      }, "no orders yet")));
    }), missingN > missing.length ? /*#__PURE__*/React.createElement("p", {
      className: "trr-muted trr-small"
    }, "Showing ", count(missing.length), " of ", count(missingN), " dealers.") : null) : /*#__PURE__*/React.createElement("p", {
      className: "trr-muted trr-small"
    }, listPending ? "Loading the dealer list…" : listFailed ? "We couldn't load the dealer list right now. Try again in a moment." : "The dealer list for this product is not available yet.")) : null);
  }
}
export default withRouter(RepCompareComponent);